import React, { Component } from 'react';
import moment from 'moment';

import TinyNodeSensorSettingsForm from './TinyNodeSensorSettingsForm';

import { defaultSorter, dateSorter } from './Helpers';
import TinyNodeSensorsModel from './TinyNodeSensorsModel';
import UserModel from './UserModel';

import { Table, Badge, Row, Col, Statistic, Popconfirm, Divider, message, Typography } from 'antd';

class ParkinglocationPlacesTable extends Component {

  state = {
    children: [],
    filteredInfo: {},
    sortedInfo: {},
    tinyNodeSensorSettingsFormData: null
  }

  handleChange = (pagination, filters, sorter) => {
    this.setState({
      filteredInfo: filters,
      sortedInfo: sorter,
    });
  }

  render() {

    let { sortedInfo, filteredInfo } = this.state;

    const columns = [{
      title: 'Místo',
      dataIndex: 'placeID',
      key: 'placeID',
      width: 150,
      defaultSortOrder: 'ascend',
      sorter: (a, b) => defaultSorter(a.placeID, b.placeID)
    }, {
      title: 'Stav',
      dataIndex: 'occ',
      key: 'occ',
      filters: [{
        text: 'OBSAZENO',
        value: 1,
      }, {
        text: 'VOLNO',
        value: 0,
      }],
      width: 200,
      filteredValue: filteredInfo.occ || null,
      onFilter: (value, record) => { return (parseInt(record.occ) === parseInt(value)) ? true : false },
      sorter: (a, b) => defaultSorter(a.occ, b.occ),
      render: (text, record) => {
        if (record.occ === 1) {
          return (
            <Badge
              status="error"
              text={"OBSAZENO"}
              title="Obsazeno" />
          );
        } else {
          return (
            <Badge
              status="success"
              text={"VOLNO"}
              title="Volno" />
          );
        }
      }
    }, {
      title: 'Aktuální role',
      dataIndex: 'actualRoleName',
      key: 'actualRoleName',
      width: 200
    }, {
      title: 'Z. šířka',
      render: (text, record) => {
        return record.coords != null || record.coords != undefined ?
          record.coords.coordinates[1]
          :
          "-"
      }
    }, {
      title: 'Z. výška',
      render: (text, record) => {
        return record.coords != null || record.coords != undefined ?
          record.coords.coordinates[0]
          :
          "-"
      }
    }, {
      title: 'Poslední změna stavu',
      dataIndex: 'lastStateChange',
      key: 'lastStateChange',
      width: 200,
      sorter: (a, b) => dateSorter(a.lastStateChange, b.lastStateChange),
      render: (text, record) => {
        return moment(text).format('L LTS');
      }
    }, {
      title: 'Akce',
      key: 'Action',
      width: 100,
      render: (text, record) => {
        if (UserModel.isInRoles(['ADMIN', 'CORE_PARKINGLOCATIONS_PLACES_WRITE'])) {
          return (
            <div>
              <Popconfirm placement="right" title="Opravdu si přejete záznam smazat?" onConfirm={() => {
                this.props.onRemoveRow
                  ? this.props.onRemoveRow(record.id)
                  : null;
              }} okText="Ano" cancelText="Ne">
                <a onClick={(e) => { e.preventDefault(); }}><Typography.Text type="danger">Smazat</Typography.Text></a>
              </Popconfirm>
            </div>
          );
        }
      }
    }];

    return (
      <div>
        <Table
          size='small'
          rowKey={this.props.rowKey ? this.props.rowKey : 'id'}
          loading={this.props.loading ? this.props.loading : false}
          columns={columns}
          dataSource={this.props.data}
          onChange={this.handleChange}
          pagination={{
            showSizeChanger: true,
            defaultPageSize: localStorage.getItem('table_pageSize') !== undefined
              ? parseInt(localStorage.getItem('table_pageSize'))
              : 10,
            onShowSizeChange: (current, size) => {
              localStorage.setItem('table_pageSize', size);
            }
          }}
          style={{ border: '0px' }} />
      </div>
    );
  }
}

export default ParkinglocationPlacesTable;


// WEBPACK FOOTER //
// ./src/components/ParkinglocationPlacesTable.js